module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Biomatic ใช้ Grid 12 ในการทำ Responsive Grid\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Container\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#layout-responsive-grid"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Responsive Grid\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-1")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-2")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-3")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-4")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-6")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-12")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-1-11")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-2-10")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-3-9")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-4-5")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-5-7")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-7-5")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-8-4")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-9-3")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-10-2")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-11-1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Breakpoint:")]), _vm._v(" Yes\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Option:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("All Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Vertical Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Horizontal Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Column Alignment: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-center")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-start")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-end")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-stretch")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Row Alignment: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-center")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-start")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-end")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-stretch")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Symmetry Grid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grid 1 -->\n<div class=\"lo-1 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 3 -->\n<div class=\"lo-3 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 6 -->\n<div class=\"lo-6 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-1")]), _vm._v(" "), _c('div', {
    staticClass: "lo-1 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-3")]), _vm._v(" "), _c('div', {
    staticClass: "lo-3 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-6")]), _vm._v(" "), _c('div', {
    staticClass: "lo-6 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Unsymmetry Grid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grid 8-4 -->\n<div class=\"lo-8-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 3-9 -->\n<div class=\"lo-3-9 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 11-1 -->\n<div class=\"lo-11-1 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-3-9")]), _vm._v(" "), _c('div', {
    staticClass: "lo-3-9 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-11-1")]), _vm._v(" "), _c('div', {
    staticClass: "lo-11-1 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการเปลี่ยนขนาด Gutter ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- All Gutter 32px -->\n<div class=\"lo-8-4 -gap-32px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Vertical Gutter 16px, Horizontal Gutter 4px -->\n<div class=\"lo-8-4 -gapv-16px -gaph-4px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-gap-32px")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-32px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-gapv-16px .-gaph-4px")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gapv-16px -gaph-4px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการ Alignment Item ใน Grid ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- ยืด Grid Item ให้เต็ม Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-stretch\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ที่ปลาย Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-end\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ที่ต้น Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-start\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ตรงกลาง Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-center\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-stretch")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-stretch _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-end")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-end _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-start")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-start _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-center")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-center _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการร่วมกับ Responsive Breakpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nGrid 12,\nGrid 6 when Small width,\nGrid 8-5 when Medium whdth\nand\nGrid 2-10 when Large width\n-->\n<div class=\"lo-12 lo-6-sm lo-8-4-md lo-2-10-lg -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-12 .lo-6-sm .lo-8-4-md .lo-2-10-lg")]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-6-sm lo-8-4-md lo-2-10-lg -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72eef612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/LayoutResponsiveGrid.vue
// module id = 138
// module chunks = 0